import $ from 'jquery';

function applyHeroEffects() {
  let header = $('.header');
  let section = $('.section_hero > .section__in');
  let heading = section.find('.hero > .hero__in');
  let yOffset = window.pageYOffset;
  let h = header.outerHeight() + section.outerHeight() - heading.outerHeight();

  // Headings Fading Out Effect
  let opacity = Math.max(0, 1 - (yOffset / h));
  heading.css('opacity', opacity);
  if (opacity > 0) {
    heading.css('display', 'block');
  } else {
    heading.css('display', 'none');
  }

  // Background Parallax Effect
  let y = `calc(100% + 0.3333 * ${yOffset}px)`;
  section.css('background-position-y', y);
}

window.addEventListener('scroll', applyHeroEffects);
window.addEventListener('load', applyHeroEffects);
